import { createSelector } from '@reduxjs/toolkit';
import { selfPixelsSelector } from './self';

const pixelSelector = createSelector(selfPixelsSelector, (pixels) => pixels.pixel);

export default pixelSelector;
